import { pathJoin } from 'src/reducers/routing/utils'

export const createCreateRouteMap = (prefix: string) => ({
  general: pathJoin(prefix)('general').chain,
})
